module.exports = __webpack_public_path__ + "i18n/zh-CN.aa10a7e87646bf3bd448157bfa5e7e58.json";